import { Http } from "@Services";
import { AccountModel } from "@Interfaces";

const loginFacebook = async (
    data: AccountModel.PostLoginRequest
): Promise<AccountModel.PostLoginResponse> => {
    let response: AccountModel.PostLoginResponse;
    try {
        response = await Http.Request<AccountModel.PostLoginResponse>({
            method: "POST",
            url: "/account/loginFacebook",
            data,
        });
    } catch (error) {
        throw Error(error);
        // @todo add user error handler
    }
    return response;
};

export default loginFacebook;
